import { useEffect, useState } from 'react';
import { useConversations } from '../contexts/CommunicationNavigationContext';
import { communications, COMMUNICATIONS_CHANGED, communicationError, type Conversation } from '../services/communications.service';
export interface ProConversationFeed { rows: Conversation[]; loading: boolean; error: string }
/** PRO queues include every conversation; the Home feed remains personal. */
export function useProConversations(pro: string, enabled = true): ProConversationFeed {
  const { identity } = useConversations();
  const [state, setState] = useState({ pro, identity, rows: [] as Conversation[], loading: true, error: '' });
  useEffect(() => {
    if (!enabled || !/^\d+$/.test(pro)) return;
    let active = true;
    let busy = false;
    const load = async () => {
      if (busy) return;
      busy = true;
      try {
        const rows = await communications.list(pro);
        if (active) setState({ pro, identity, rows, loading: false, error: '' });
      } catch (e) {
        if (active) setState(prev => ({ pro, identity, rows: prev.pro === pro && prev.identity === identity ? prev.rows : [], loading: false, error: communicationError(e) }));
      } finally { busy = false; }
    };
    void load();
    const timer = window.setInterval(() => void load(), 15000);
    window.addEventListener(COMMUNICATIONS_CHANGED, load);
    window.addEventListener('focus', load);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener(COMMUNICATIONS_CHANGED, load);
      window.removeEventListener('focus', load);
    };
  }, [pro, identity, enabled]);
  if (!/^\d+$/.test(pro)) return { rows: [], loading: false, error: '' };
  return state.pro === pro && state.identity === identity ? state : { rows: [], loading: true, error: '' };
}
